import $ from 'jquery'
import i18n from 'scoreboard/components/i18n'

function renderTransformationThen(el, operator) {
	el = $(el)
	let selector = '.make, .replace, .append-prepend, .use-or-remove-characters,' +
		' .remove-types-of-characters, .format'
	el.find(selector).addClass('is-not-displayed')
	el.find('.transformation-then-options').removeClass('is-not-displayed')
	// #57219 make sure the action selector starts out visible, in case it
	// was previously hidden by "primary" field selection, such as
	// "do-not-import-record" or "remove-record".  It will be re-hidden
	// below if the current field is considered a "primary" action.
	el.find('.action').removeClass('is-not-displayed')
	if (operator === 'make-x') {
		el.find('.make').removeClass('is-not-displayed')
	}
	if (operator === 'replace') {
		el.find('.replace').removeClass('is-not-displayed')
	}
	if (operator === 'append' || operator === 'prepend') {
		el.find('.append-prepend').removeClass('is-not-displayed')
		// #30824 add labels
		let label
		if (operator === 'append') {
			label = i18n.get('template.suffix')
		} else {
			label = i18n.get('template.prefix')
		}
		el.find('.append-prepend-label').text(label)

	}
	if (operator === 'use-first-characters' || operator === 'use-last-characters' ||
		operator === 'remove-first-characters' || operator === 'remove-last-characters') {
		el.find('.use-or-remove-characters').removeClass('is-not-displayed')
	}
	if (operator === 'remove-types-of-characters') {
		el.find('.remove-types-of-characters').removeClass('is-not-displayed')
	}
	if (operator === 'primary-action' || operator === 'do-not-import-record' ||
			operator=== 'make-kpi-value-na' || operator === 'remove-record') {
		// this hides the then operator and all options on transformation form
		// except for the button to delete the transformation-then (#57169)
		el.find('.transformation-then-options').children().not('a').addClass('is-not-displayed')
		// this hides the field label for then-display.hbs
		el.find('.field-label').addClass('is-not-displayed')
	}
	if (operator === 'convert-to-date') {
		el.find('.format').removeClass('is-not-displayed')
	}
}

export default renderTransformationThen

renderTransformationThen.__filename__ = 'imports/transform/render-transformation-then.js'
